// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var WebEnvVars = require("../../WebEnvVars.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var ReactDOMStyle = require("reason-react/src/ReactDOMStyle.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");
var ReactPlaidLink = require("react-plaid-link").default;
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebGraphql_Payments = require("../../graphql/WebGraphql_Payments.bs.js");
var WebBindings_PlaidLink = require("../../bindings/WebBindings_PlaidLink.bs.js");
var BrowserComponents_Card = require("../../../../shared-browser/src/components/BrowserComponents_Card.bs.js");
var BrowserComponents_Form = require("../../../../shared-browser/src/components/BrowserComponents_Form.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var BrowserBindings_ReactStripe = require("../../../../shared-browser/src/bindings/BrowserBindings_ReactStripe.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");

var stripeApiKey = WebEnvVars.vars.stripeApiKey;

var plaidPublicKey = WebEnvVars.vars.plaidPublicKey;

var plaidEnv = WebEnvVars.vars.plaidEnv;

function WebContainers_BusinessDashboard_Payments$CreditCard(Props) {
  var onSuccess = Props.onSuccess;
  return React.createElement(BrowserBindings_ReactStripe.make, BrowserBindings_ReactStripe.makeProps((function (param) {
                    var match = BrowserBindings_ReactStripe.CardElement.useElement("creditCardInput", Caml_option.some(Js_dict.fromList({
                                  hd: [
                                    "base",
                                    Object.assign({}, ReactDOMStyle.unsafeAddProp({
                                              color: "#4E535C",
                                              fontSize: "16px"
                                            }, "fontSmoothing", "antialiased"), {
                                          "::placeholder": {
                                            color: "#CCC"
                                          }
                                        })
                                  ],
                                  tl: {
                                    hd: [
                                      "invalid",
                                      {
                                        color: "#E6283D"
                                      }
                                    ],
                                    tl: /* [] */0
                                  }
                                })), undefined);
                    return React.createElement(BrowserComponents_Form.make, {
                                onSubmit: Curry._1(onSuccess, Curry._3(BrowserBindings_ReactStripe.Stripe.Token.Create.createCardToken, match[0], param.elements, param.stripe)),
                                children: null
                              }, React.createElement(BrowserComponents_Card.make, {
                                    children: match[1]
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Medium */4
                                  }), React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* Primary */0,
                                    onClick: (function (param) {
                                        return Relude_IO.pure(undefined);
                                      }),
                                    title: "Submit",
                                    type_: "submit"
                                  }));
                  }), stripeApiKey, undefined, undefined));
}

var CreditCard = {
  make: WebContainers_BusinessDashboard_Payments$CreditCard
};

var container = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.row),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.mobileMedia({
                          hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                          tl: {
                            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                            tl: /* [] */0
                          }
                        }),
                    tl: {
                      hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.zero),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var description = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

function arg(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined, undefined), /* [] */0));

var paymentMethodButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.zero),
        tl: /* [] */0
      }
    });

var successContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

function arg$1(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Bold */2);
}

var successTitle = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined, undefined), /* [] */0));

var errorText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var tryAgainButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.flexStart),
      tl: /* [] */0
    });

var Styles = {
  container: container,
  content: content,
  description: description,
  title: title,
  paymentMethodButton: paymentMethodButton,
  successContainer: successContainer,
  successTitle: successTitle,
  errorText: errorText,
  tryAgainButton: tryAgainButton
};

function setupPaymentMethod(param_0) {
  return {
          TAG: /* SetupPaymentMethod */0,
          _0: param_0
        };
}

function finishingPaymentMethodSetup(param_0, param_1) {
  return {
          TAG: /* FinishingPaymentMethodSetup */1,
          _0: param_0,
          _1: param_1
        };
}

function WebContainers_BusinessDashboard_Payments(Props) {
  var authorizedClient = Props.authorizedClient;
  var setView = Props.setView;
  var param = Props.user;
  var businessId = param.business.id;
  var match = ReactIO.useState(function (param) {
        return /* SelectPaymentMethod */0;
      });
  var setStatus = match[1];
  var status = match[0];
  var selectorsDisabled;
  selectorsDisabled = typeof status === "number" || status.TAG === /* SetupPaymentMethod */0 ? false : true;
  var tmp;
  if (typeof status === "number") {
    tmp = null;
  } else if (status.TAG === /* SetupPaymentMethod */0) {
    if (status._0) {
      var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
              
            }));
      var partial_arg$1 = function (param) {
        return Relude_Globals.$great$great(partial_arg, (function (param) {
                      return Relude_IO.flatMap((function (token) {
                                    return Relude_IO.flatMap((function (param) {
                                                  return Relude_Globals.$great$great((function (param) {
                                                                return Relude_Globals.$great$great((function (param) {
                                                                              return Relude_AsyncData.map(Relude_Result.pure, param);
                                                                            }), (function (param) {
                                                                              return {
                                                                                      TAG: /* FinishingPaymentMethodSetup */1,
                                                                                      _0: /* CreditCard */1,
                                                                                      _1: param
                                                                                    };
                                                                            }), param);
                                                              }), setStatus, param);
                                                }), Relude_IO.flatMap((function (param) {
                                                      return Curry._2(Relude_IO.mapError, (function (prim) {
                                                                    
                                                                  }), Curry._2(WebGraphql_Payments.ConnectStripe.mutateAsyncData, {
                                                                      businessId: businessId,
                                                                      tokenId: token.id
                                                                    }, authorizedClient));
                                                    }), Curry._1(setStatus, {
                                                        TAG: /* FinishingPaymentMethodSetup */1,
                                                        _0: /* CreditCard */1,
                                                        _1: Relude_AsyncResult.loading
                                                      })));
                                  }), param);
                    }), param);
      };
      tmp = React.createElement(WebContainers_BusinessDashboard_Payments$CreditCard, {
            onSuccess: (function (param) {
                return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                              return Relude_IO.catchError((function (param) {
                                            return Relude_IO.pure(undefined);
                                          }), param);
                            }), param);
              })
          });
    } else {
      tmp = React.createElement(ReactPlaidLink, Curry._3(WebBindings_PlaidLink.makeProps(undefined, (function (publicToken, accountId) {
                        return Relude_IO.flatMap((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_AsyncData.map(Relude_Result.pure, param);
                                                                }), (function (param) {
                                                                  return {
                                                                          TAG: /* FinishingPaymentMethodSetup */1,
                                                                          _0: /* ACH */0,
                                                                          _1: param
                                                                        };
                                                                }), param);
                                                  }), setStatus, param);
                                    }), Relude_IO.flatMap((function (param) {
                                          return Curry._2(Relude_IO.mapError, (function (prim) {
                                                        
                                                      }), Curry._2(WebGraphql_Payments.ConnectPlaid.mutateAsyncData, {
                                                          accountId: accountId,
                                                          businessId: businessId,
                                                          publicToken: publicToken
                                                        }, authorizedClient));
                                        }), Curry._1(setStatus, {
                                            TAG: /* FinishingPaymentMethodSetup */1,
                                            _0: /* ACH */0,
                                            _1: Relude_AsyncResult.loading
                                          })));
                      }), plaidPublicKey)("Connect Bank Account", "Qwick"), plaidEnv, undefined, undefined));
    }
  } else {
    var paymentMethod = status._0;
    tmp = Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.make, {}), (function (param) {
            return React.createElement(BrowserComponents_FlexColumn.make, {
                        className: successContainer,
                        children: null
                      }, React.createElement(BrowserComponents_Image.make, {
                            image: {
                              TAG: /* Illustration */1,
                              _0: /* ThumbsUp */86
                            }
                          }), React.createElement(BrowserComponents_Text.make, {
                            className: successTitle,
                            children: "Payment Information Updated!"
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Small */3
                          }), React.createElement(BrowserComponents_Text.make, {
                            children: "Thank you! We've successfully updated your payment information."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Large */5
                          }), React.createElement(BrowserComponents_Button.make, {
                            actionPriority: /* Primary */0,
                            onClick: (function (param) {
                                return Curry._1(setView, {
                                            TAG: /* BusinessDashboard */0,
                                            _0: {
                                              TAG: /* ShiftsList */1,
                                              _0: /* Upcoming */1
                                            }
                                          });
                              }),
                            title: "Back to Dashboard"
                          }));
          }), (function (param) {
            return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                            className: errorText,
                            children: "There was an error setting up your payment information."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Medium */4
                          }), React.createElement(BrowserComponents_Button.make, {
                            actionPriority: /* Primary */0,
                            className: tryAgainButton,
                            onClick: (function (param) {
                                return Curry._1(setStatus, {
                                            TAG: /* SetupPaymentMethod */0,
                                            _0: paymentMethod
                                          });
                              }),
                            title: "Try Again"
                          }));
          }), status._1);
  }
  return React.createElement("main", {
              className: container
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: content,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      className: description,
                      children: "Qwick uses Stripe to keep your payment information secure. Thousands of companies around the world trust Stripe to process payments for their users."
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: title,
                      children: "Select your method of payment:"
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      children: null
                    }, React.createElement(BrowserComponents_Button.Selector.make, {
                          className: paymentMethodButton,
                          children: React.createElement(BrowserComponents_Text.make, {
                                children: "ACH"
                              }),
                          disabled: selectorsDisabled,
                          isSelected: typeof status === "number" || status._0 ? false : true,
                          onClick: (function (param) {
                              return Curry._1(setStatus, {
                                          TAG: /* SetupPaymentMethod */0,
                                          _0: /* ACH */0
                                        });
                            })
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Small */3
                        }), React.createElement(BrowserComponents_Button.Selector.make, {
                          className: paymentMethodButton,
                          children: React.createElement(BrowserComponents_Text.make, {
                                children: "Credit Card"
                              }),
                          disabled: selectorsDisabled,
                          isSelected: typeof status === "number" || !status._0 ? false : true,
                          onClick: (function (param) {
                              return Curry._1(setStatus, {
                                          TAG: /* SetupPaymentMethod */0,
                                          _0: /* CreditCard */1
                                        });
                            })
                        })), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), tmp));
}

var selectPaymentMethod = /* SelectPaymentMethod */0;

var make = WebContainers_BusinessDashboard_Payments;

exports.plaidEnv = plaidEnv;
exports.plaidPublicKey = plaidPublicKey;
exports.stripeApiKey = stripeApiKey;
exports.CreditCard = CreditCard;
exports.Styles = Styles;
exports.selectPaymentMethod = selectPaymentMethod;
exports.setupPaymentMethod = setupPaymentMethod;
exports.finishingPaymentMethodSetup = finishingPaymentMethodSetup;
exports.make = make;
/* container Not a pure module */
